import { Stack } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { Button, ButtonVariant } from 'components/common/Button'
import { ButtonsContainer } from './DateTabContent.style'

interface MobileButtonsProps {
  apply?: () => void
  clear: () => void
}

export const Buttons = ({ apply, clear }: MobileButtonsProps) => {
  const { t } = useTranslation('home')
  return (
    <ButtonsContainer
      gap={2}
      justifyContent={{ xs: 'space-between', md: 'flex-end' }}
    >
      <Stack flex={{ xs: 1, md: 'unset' }} width={{ xs: '100%', md: 'unset' }}>
        <Button
          label={t('head.clear')}
          fullWidthOnMobile
          variant={ButtonVariant.Quaternary}
          onClick={clear}
        />
      </Stack>
      {apply && (
        <Stack
          flex={{ xs: 1, md: 'unset' }}
          width={{ xs: '100%', md: 'unset' }}
        >
          <Button
            label={t('head.apply')}
            fullWidthOnMobile
            variant={ButtonVariant.Primary}
            onClick={apply}
          />
        </Stack>
      )}
    </ButtonsContainer>
  )
}
